import clsx from 'clsx'
import React from 'react'
import styles from './Button.module.css'

export interface ButtonProps {
    variant?: "text" | "outlined" | "contained"
    children?: React.ReactNode
    disabled?: boolean
    icon?: React.ComponentType<any>
    onClick?: () => void    
}

export default function Button(props: ButtonProps) {
    const variant = props.variant || "text"
    const iconOnly = props.icon && !props.children

    return (
        <button
            className={clsx(
                styles.button,
                styles[variant],
                { [styles.iconOnly]: iconOnly }  
            )}
            disabled={props.disabled}
            onClick={props.onClick}
        >
            { props.icon &&
                <props.icon className={styles.icon} />
            }
            <span className={styles.label}>
                {props.children}
            </span>
        </button>
    )
}   